import { translate } from '../../features/translate/translate';
import { EStatus } from '../../shared/enums/status.enum';

export const humanizeStatus = (_status: EStatus): string => {
  switch (_status) {
    case EStatus.OPEN:
      return translate('open');
    case EStatus.IN_PROGRESS:
      return translate('in_progress');
    case EStatus.ONHOLD:
      return translate('on_hold');
    case EStatus.TO_REVIEW:
      return translate('to_review');
    case EStatus.CANCELED:
      return translate('canceled');
    case EStatus.CLOSED:
      return translate('completed');
    default:
      return _status;
  }
};

export const dehumanizeStatus = (_status: string): EStatus => {
  switch (_status) {
    case translate('open'):
      return EStatus.OPEN;
    case translate('in_progress'):
      return EStatus.IN_PROGRESS;
    case translate('on_hold'):
      return EStatus.ONHOLD;
    case translate('to_review'):
      return EStatus.TO_REVIEW;
    case translate('canceled'):
      return EStatus.CANCELED;
    case translate('completed'):
      return EStatus.CLOSED;
    default:
      return null;
  }
};
